/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { useEffect } from "react";

import { ScreenController } from "../../model/navigation";
import { useNavigationEngine } from "./useNavigationEngine";

/**
 * Registers a ScreenController with the NavigationEngine on mount
 * and unregisters it on unmount.
 *
 * Usage:
 *   const controller = useMemo(() => new MyScreenController(deps), [deps]);
 *   useScreenController(controller);
 */
export function useScreenController(controller: ScreenController): void {
  const engine = useNavigationEngine();

  useEffect(() => {
    engine.registerScreen(controller);

    return () => {
      engine.unregisterScreen(controller.screenName);
    };
  }, [engine, controller]);
}
